var map = {
	"./pistol_default_idle.svg": 337,
	"./pistol_law_prestige_idle.svg": 9448,
	"./rifle_default_idle.svg": 6710,
	"./rifle_mafia_rouge_idle.svg": 4039,
	"./shield_default_idle.svg": 1301,
	"./shotgun_default_idle.svg": 3675,
	"./sniper_default_idle.svg": 5079
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3639;